<template>
  <div id="order_history">
    <section>
      <div class="flex-just-space">
        <div class="list_left_container">
          <ul>
            <li class="list_left3 order_title">
              <span>注文番号</span>
              <span>{{orderData.orderNo}}</span>
            </li>
            <li class="list_left">
              <span>ご注文日</span>
              <span>{{getDate(orderData.odDate)}}</span>
            </li>
            <li class="list_left">
              <span>ご請求額</span>
              <span>{{formatPrice(orderData.price)}}</span>
            </li>
            <li class="list_left">
              <span>施主名</span>
              <span>{{orderData.infoName}}</span>
            </li>
            <li class="list_left">
              <span>納品先</span>
              <span>{{deliAddress}}</span>
            </li>
          </ul>
        </div>
        <button class="main_btn middle_btn" @click="detail()">詳細を見る</button>
      </div>
    </section>
  </div>
</template>
<script>
import moment from 'moment'
// import * as FormUtil from '../../../utils/FormUtil'

export default {
  name: 'DcOrderHistory',
  components: {
  },
  props: {
    orderData: Object
  },
  data () {
    return {
    }
  },
  computed: {
    deliAddress: function () {
      let address = (this.orderData.infoDeliState ? this.orderData.infoDeliState : '') +
        (this.orderData.infoDeliCity ? this.orderData.infoDeliCity : '') +
        (this.orderData.infoDeliStreet ? this.orderData.infoDeliStreet : '')
      return address
    }
  },
  methods: {
    detail: function () {
      this.$router.push({
        name: 'OrderHistoryDetail',
        params: { orderNo: this.orderData.orderNo }
      })
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    getDate: function (date) {
      if (!moment(date).isValid()) return ''
      let time = moment(date).format('YYYY/MM/DD')
      return time
    },
    cancel: function () {
      this.$router.go(-1)
    }
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>
<style src="../../css/dctop2.scss" lang="scss" scoped></style>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/input-list.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.list_left_container {
  width: 70%;
  font-weight: bold;
}

.order_title {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/components/order/DcOrderHistory.vue